import axios from 'axios';
import { mavim } from '../../app/conf';

const headers = token => ({
    'Content-Type': 'application/json',
    'x-access-token': token
});

export const getUserSettingsScreen = (screen, token) =>
    axios({
        method: 'get',
        url: `${mavim.baseUrl}/api/v1/user-settings/${screen}`,
        headers: headers(token)
    });

export const putUserSettingsScreen = (screen, filters, token) =>
    axios({
        method: 'put',
        url: `${mavim.baseUrl}/api/v1/user-settings/${screen}`,
        headers: headers(token),
        data: { filters }
    });

export const deleteUserSettingsScreen = (screen, token) =>
    axios({
        method: 'delete',
        url: `${mavim.baseUrl}/api/v1/user-settings/${screen}`,
        headers: headers(token)
    });
